import React from 'react';

import { NavLink, withRouter } from "react-router-dom";

import { Layout, theme } from 'antd';
import LegalFooter from "./widgets/LegalFooter";
import {css, Global as GlobalStyles} from "@emotion/react";
const { Content } = Layout;

const NakedLayout = withRouter(props => {
    const {token} = theme.useToken()

    return (
        <Layout style={{height:'100vh'}}>
            <GlobalStyles
                styles={css`
                    body { background-color: ${token.colorBgLayout}; }
                `}
            />

            <Content
                style={{
                    padding: 24,
                    margin: 0,
                }}
            >
                {props.children}

                <LegalFooter/>
            </Content>
        </Layout>
    );
});

export default NakedLayout;
